import { EReportPermissions } from '@Enum/auth.enum'
import ReportLayout from '@Layouts/Report/ReportLayout'
import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

interface IReportRoute {
    exact?: boolean
    path?: string
    component: any
    user?: any
}

const ReportRoute: React.FC<IReportRoute> = ({
    component: Component,
    exact,
    path,
    user,
}) => {
    return (
        <Route
            exact={exact}
            path={path}
            render={(props: any) => {
                if (user?.permissions?.includes(EReportPermissions?.LOGIN)) {
                    return (
                        <ReportLayout>
                            <Component {...props} />{' '}
                        </ReportLayout>
                    )
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }}
        />
    )
}

const mapStateToProps = (state: any) => {
    const { user } = state?.auth

    return {
        user,
    }
}

export default connect(mapStateToProps, null)(ReportRoute)
